module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-channelbanlist"
  }, [_c('form', {
    staticClass: "u-form kiwi-channelbanlist",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('a', {
    staticClass: "u-link",
    on: {
      "click": _vm.updateBanlist
    }
  }, [_vm._v(_vm._s(_vm.$t('bans_refresh')))]), _vm._v(" "), (_vm.banlist.length > 0) ? _c('table', {
    staticClass: "kiwi-channelbanlist-table"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('bans_user')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('bans_by')))]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.banlist), function(ban) {
    return _c('tr', [_c('td', {
      staticClass: "kiwi-channelbanlist-table-mask"
    }, [_vm._v(_vm._s(ban.banned))]), _vm._v(" "), _c('td', {
      staticClass: "kiwi-channelbanlist-table-bannedby"
    }, [_vm._v(_vm._s(ban.banned_by))]), _vm._v(" "), _c('td', {
      staticClass: "kiwi-channelbanlist-table-bannedat"
    }, [_vm._v(_vm._s((new Date(ban.banned_at * 1000)).toDateString()))]), _vm._v(" "), _c('td', {
      staticClass: "kiwi-channelbanlist-table-actions"
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.removeBan(ban.banned)
        }
      }
    })])])
  })], 2) : (_vm.is_refreshing) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.$t('bans_refreshing')) + "\n        ")]) : _c('div', {
    staticClass: "kiwi-channelbanlist-empty"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('bans_nobody')) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a0d37a96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChannelBanlist.vue
// module id = 504
// module chunks = 2